import React from 'react';
import { Button, FormInputRadioBox } from 'modules/common/input';
import { Link, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import ErrorLabel from 'modules/common/components/ErrorLabel';
import { storage } from 'modules/common/helper';
import { showModal } from 'modules/common/modal';
import PageTitle from 'modules/common/components/PageTitle';

const INIT_FORM = {
  is_manila_citizen: '',
};

const schema = yup.object({
  is_manila_citizen: yup
    .string()
    .required('Please specify if you are a resident of Manila')
    .nullable(true),
});

function Resident() {
  const [isLoading, setIfLoading] = React.useState(false);
  const history = useHistory();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: INIT_FORM,
    resolver: yupResolver(schema),
  });

  const handleOnSubmit = (form) => {
    setIfLoading(true);
    setTimeout(() => {
      setIfLoading(false);
      if (form?.is_manila_citizen === 'Yes') {
        storage.set('residence', form);
        history.push('/register/personal');
        return;
      }
      showModal({
        title: false,
        isFocusTrap: false,
        modalSize: 'modal-sm',
        noClose: true,
        content: (onClose) => (
          <div className="space-y-6">
            <h1 className="text-primary-500 font-medium">
              Sorry, we can’t proceed with your application as this if for
              Manila Residents only.
            </h1>
            <div className="flex justify-center">
              <Button
                className="btn md primary w-72"
                label="Okay"
                onClick={(e) => {
                  e.preventDefault();
                  onClose();
                  history.push('/');
                }}
              />
            </div>
          </div>
        ),
      });
    }, 500);
  };

  return (
    <>
      <PageTitle title="Resident | Manila E-Citizen" />
      <form onSubmit={handleSubmit(handleOnSubmit)}>
        <div className="space-y-8">
          <p>Are you a resident of Manila?</p>
          <div className="flex gap-4">
            <div className="flex-intial border border-gray-200 shadow-sm rounded-lg p-3 inline">
              <FormInputRadioBox
                label="Yes"
                value="Yes"
                name="is_manila_citizen"
                ref={{ ...register('is_manila_citizen') }}
              />
            </div>
            <div className="flex-intial border border-gray-200 shadow-sm rounded-lg p-3 inline">
              <FormInputRadioBox
                label="No"
                value="No"
                name="is_manila_citizen"
                ref={{ ...register('is_manila_citizen') }}
              />
            </div>
            <div className="flex-intial">
              <ErrorLabel error={errors?.is_manila_citizen} />
            </div>
          </div>
          <div className="space-y-3">
            <Button
              type="submit"
              isLoading={isLoading}
              className="btn primary md font-base text-sm"
              label="Next"
            />
            <p className="font-light text-sm text-primary-500">
              Already have an account?{' '}
              <Link
                to="/login"
                className="font-semibold text-sm ml-auto hover:underline"
              >
                Login now.
              </Link>
            </p>
          </div>
        </div>
      </form>
    </>
  );
}
Resident.defaultProps = {};

Resident.propTypes = {};

export default Resident;
